<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Samuel
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To teach that God always answers his people’s prayers so as to bring about his good plans for them.
                        </li>
                        <li>
                            To understand that God’s word is essential for the growth of his people.
                        </li>
                        <li>
                            To teach that those who lead God’s people must hear, obey and teach his word.
                        </li>
                        <li>
                            To understand that the normal Christian life involves ongoing repentance and faith.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series explores three stages of Samuel's life: his birth, his call to be a prophet as a boy and his rule as judge.
                        God carefully chose Samuel to lead his people and to teach them to live in faithful obedience to him.
                        Each lesson covers two key aspects of life as God’s people:
                    </p>

                    <ul>
                        <li>
                            God’s sovereign rule – even before Samuel was born God was clearly in control of events.
                            He had prevented Hannah from having children and then gave her a son in answer to her prayer (week 1);
                            he made sure that Samuel grew up in the temple and then called him to lead God’s people (weeks 1 and 2);
                            he gave the people his word through his chosen prophet (weeks 2 and 3);
                            and he answered Samuel’s prayer by rescuing the Israelites from their enemies (week 3).
                        </li>
                        <li>
                            The people’s response of faith – Hannah trusted God in her childlessness and pleaded with him
                            to grant her a son (week 1); Samuel heard God’s call and spoke the truth despite the difficult
                            message he had to convey (week 2); Eli accepted God’s word spoken through Samuel and so did the people (weeks 2 and 3);
                            Samuel trusted God to rescue his people (week 3); and Israel demonstrated their faith by accepting the of the word
                            of the Lord in the mouth of his prophet and repenting of their idolatry (week 3).
                        </li>
                    </ul>

                    <p>
                        The life of God’s people is much the same today: we must come to our sovereign
                        God in faith and respond to his rescue in obedience.
                        Unlike the Israelites, however, we have an even greater priest, prophet and judge who is able to
                        save and sustain us as we trust in him and listen to his word.
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - Samuel, the Baby (1 Samuel 1:1-28)
                    </p>
                    <p>
                        Lesson 2 - Samuel, the Prophet (1 Samuel 2:12-18, 22-26, 3:1-4:1a)
                    </p>
                    <p>
                        Lesson 3 - Samuel, the Judge (1 Samuel 7:2-17)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Samuel",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Samuel`,
            meta: [
                {
                    name: 'description',
                    content: "To understand that God’s word is essential for the growth of his people.",
                },
            ],
        };
    },
};
</script>
